var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1067 3.22667C12.8157 2.9355 12.4701 2.70455 12.0898 2.54702C11.7095 2.38949 11.3018 2.30841 10.8901 2.30841C10.4783 2.30841 10.0706 2.38949 9.69032 2.54702C9.31003 2.70455 8.96443 2.9355 8.6734 3.22667L8.00007 3.9L7.32673 3.22667C6.73889 2.63883 5.94143 2.30853 5.11007 2.30853C4.27871 2.30853 3.48125 2.63883 2.8934 3.22667C2.30556 3.81451 1.97526 4.61197 1.97526 5.44333C1.97526 6.2747 2.30556 7.07216 2.8934 7.66L3.56673 8.33333L8.00007 12.7667L12.4334 8.33333L13.1067 7.66C13.3979 7.36897 13.6289 7.02336 13.7864 6.64308C13.9439 6.26279 14.025 5.85507 14.025 5.44333C14.025 5.0316 13.9439 4.62388 13.7864 4.24359C13.6289 3.8633 13.3979 3.5177 13.1067 3.22667Z",
    stroke: "#9B0000",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.31c9d74ea80eaf6c929a24f6713eb02b.svg";
export { ForwardRef as ReactComponent };